import {
  avatarButtonContainerStyles,
  avatarContainerStyles,
  seeImageIconStyles
} from '../../../../../common/person/edit/basic-info/person-basic-information-styles'
import { Avatar, Box, IconButton, Skeleton, Tooltip, Typography } from '@mui/material'
import HideImageIcon from '@mui/icons-material/HideImage'
import { FormDialog, AlertDialog, useGlobalMessageHandler } from 'components'
import DeleteIcon from '@mui/icons-material/Delete'
import React, { useState } from 'react'
import EditIcon from '@mui/icons-material/Edit'
import { createPersonUrl, deletePersonUrl, type PersonUrl, updatePersonUrl } from 'services'

interface PersonLogoProps {
  loading: boolean
  originalLogoUrl: PersonUrl | undefined
  personId: number
}
export const PersonLogo: React.FC <PersonLogoProps> = ({ loading, originalLogoUrl, personId }) => {
  const [imageURL, setImageURL] = useState<PersonUrl | undefined>(originalLogoUrl)
  const [imageURLNewValue, setImageURLNewValue] = useState<string>('')
  const [deleteLogoConfirmationOpen, setDeleteLogoConfirmationOpen] = useState<boolean>(false)
  const { showErrorMessage, showSuccessMessage } = useGlobalMessageHandler()

  const iconButtonProps = {
    color: 'primary',
    size: 'small',
    disabled: loading,
    children: <EditIcon/>
  }

  const createNewLogo = async (newUrl: PersonUrl): Promise<void> => {
    await createPersonUrl(newUrl)
      .then((urlId) => {
        newUrl.id = urlId
        setImageURL(newUrl)
        showSuccessMessage('This person Photo has been successfully created!')
      })
      .catch(() => {
        showErrorMessage('Failed to create Person Photo')
      })
  }

  const updateLogo = async (newUrlValue: string): Promise<void> => {
    if (imageURL != null) {
      const updatedUrl: PersonUrl = { ...imageURL, value: newUrlValue }
      updatePersonUrl(updatedUrl)
        .then((updated) => {
          if (updated) {
            const updatedState = { ...imageURL, value: newUrlValue }
            setImageURL(updatedState)
            showSuccessMessage('This person Photo has been successfully updated!')
          } else {
            showErrorMessage('Failed to update Person Photo')
          }
        }).catch(() => { showErrorMessage('Unexpected error while updating Person Photo') })
    }
  }

  const handleNewLogoImage = (): void => {
    if (imageURL != null) {
      void updateLogo(imageURLNewValue)
    } else {
      const newUrl: PersonUrl = {
        descId: 5,
        displayOrder: 1,
        id: -1,
        typeId: 2,
        value: imageURLNewValue,
        personId,
        lastUpdated: ''
      }

      void createNewLogo(newUrl)
    }
  }

  const handleDeleteLogoClick = (): void => {
    setDeleteLogoConfirmationOpen(true)
  }

  const handleDeleteLogoConfirmationClose = (): void => {
    setDeleteLogoConfirmationOpen(false)
  }

  const handleDeleteLogoConfirmed = (): void => {
    if (imageURL != null) {
      void deletePersonUrl(imageURL).then(value => {
        setImageURL(undefined)
        setDeleteLogoConfirmationOpen(false)
        if (value) { showSuccessMessage('Person photo deleted') } else { showErrorMessage('Failed to delete Person photo') }
      })
    }
  }
  return (
        <Box sx={avatarContainerStyles}>
          <AlertDialog
              title="Delete Confirmation"
              contentText={'Are you sure you want to delete this photo?'}
              nameButtonCancel="Cancel"
              nameButtonConfirm="Delete"
              onButtonClick={handleDeleteLogoConfirmed}
              onClose={handleDeleteLogoConfirmationClose}
              open={deleteLogoConfirmationOpen}
          />
            <Typography variant="subtitle2">
                Photo
            </Typography>
            {!loading
              ? (
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <Box sx={avatarButtonContainerStyles}>
                          <Tooltip title={(imageURL != null) ? 'Show Photo' : 'No Photo to show'}>
                          {(imageURL == null)
                            ? <Box sx={avatarButtonContainerStyles}>
                                    <IconButton sx={{ width: '70%' }} disabled={true} onClick={() => {}}>
                                          <HideImageIcon sx={seeImageIconStyles} color='disabled'/>
                                    </IconButton>
                                </Box>
                            : <Avatar src={imageURL.value} sx={{ width: '6vw', maxWidth: 130, minWidth: 70, height: 'auto' }} onClick={() => {
                              const newTab = window.open(imageURL?.value, '_blank')
                              newTab?.focus()
                            }
                            }/>}
                          </Tooltip>
                        </Box>
                        <Box sx={avatarButtonContainerStyles}>
                            <FormDialog isShowCheckBox={false}
                                        onCheckboxChange={(isChecked, queryName) => {
                                          setImageURLNewValue(queryName)
                                        }}
                                        onButtonClick={() => {
                                          handleNewLogoImage()
                                        }} title='New value for logo' contentText='URL for new Photo'
                                        nameLabelField='Photo Url' iconButtonProps={iconButtonProps}
                                        tooltip='Edit Photo'/>
                            <Tooltip title="Delete Photo">
                                <Box>
                                    <IconButton disabled={loading || (imageURL == null)} aria-label="Delete Photo"
                                                color="secondary" onClick={() => {
                                                  handleDeleteLogoClick()
                                                }}>
                                        <DeleteIcon/>
                                    </IconButton>
                                </Box>
                            </Tooltip>
                        </Box>
                    </Box>

                )
              : (
                    <Skeleton variant="rectangular" width={150} height={220}/>
                )}
        </Box>
  )
}
